import { Button } from "@mui/material";
import JoditEditor from "jodit-react";
import { Toaster } from "modules/platform-components/Toaster";
import { config } from "process";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { MultiSelect } from "react-multi-select-component";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AppContext } from "../../context/AppContext";
import {
  defaultDisableButtonsObject,
  FeedbackColumnDefs,
  status as questionStatuses,
  WhereUsedColumnDefs
} from "../constants/QuestionBankConstants";
import {
  apiPaths,
  get,
  postData
} from "../platform-components/api-integration-util";
import { PreLoader } from "../platform-components/PreLoader";
import QuestionViewer from "../platform-components/question-viewer/QuestionViewer";
import { getItemfromStorage } from "../platform-components/utils/common-utils";
import {
  checkPermission,
  getEditQuestion
} from "../platform-components/utils/configuration";
import { getRoleNameList, getUserDetails } from "../platform-components/utils/shared-data.service";
import "./addquestion.scss";
import { answer, answerOptions } from "./constant";
import { getQuestionIds } from "./Dashboard-Service";

const AddQuestion = (props) => {
  let comments;
  const { QBEdit, qbId } = props;
  let [id, setId] = useState(useParams()?.id || qbId);
  let [showWhereUsedGrid, setShowWhereUsedGrid] = useState(true);
  let [viewQuestion, setViewQuestion] = useState(QBEdit ? false : true);
  let [question, updateQuestion] = useState({});
  let [answers, setAnswers] = useState([]);
  let [edit, updateEdit] = useState(QBEdit || getEditQuestion());
  let [loading, updateLoading] = useState(true);
  let [displyNavs, setDisplayNavs] = useState(false);
  let [disablePrev, setDisablePrev] = useState(false);
  let [disableNext, setDisableNext] = useState(false);
  let [imagePreview, setImagePreview] = useState({ file: null });
  let [downloadMedia, setDownloadMedia] = useState({});
  let [questionData, setQuestionData] = useState({});
  let [selectedQuestonId, setWhereUsedQuestionId] = useState("");
  let [whereUsedPopupgridOptions, setwhereUsedPopupgridOptions] = useState({});
  let [feedbackPopupgridOptions, setFeedbackPopupgridOptions] = useState({});

  // Check if the query string contains 'qbpage=true'
  const hash = window.location.hash;
  const queryStringIndex = hash.indexOf("?");
  const queryString =
    queryStringIndex !== -1 ? hash.slice(queryStringIndex) : "";

  const queryParams = new URLSearchParams(queryString);
  const history = useHistory();

  const isQBPage = QBEdit || queryParams.get("qbpage") === "true";

  let [uploadMediaInformation, setUploadMediaInformation] = useState({});
  let { topics, courses, tags, subjects } = useContext(AppContext);
  const [availableTopics, setAvailableTopics] = useState([]);
  const editor = useRef(null);
  const [joditValues, setJoditValues] = useState({
    questionType: "EASY",
  });

  const [multiSelectValue, setMultiSelectValue] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const [multiSelectTagValue, setMultiSelectTagValue] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [multiSelectCourseValue, setMultiSelectCourseValue] = useState([]);
  const [topicOptions, setTopicOptions] = useState([]);
  const [multiSelectTopicValue, setMultiSelectTopicValue] = useState([]);
  const [QBCount, setQBCount] = useState(0);
  const [nxtQuestion, setNxtQuestion] = useState(0);
  const [prevQuestion, setPrevQuestion] = useState(0);
  const isAdmin = getRoleNameList().includes('Admin');
  let whereUsedGridApi = useRef();
  let feedbackGridApi = useRef();

  const {
    register,
    handleSubmit,
    watch,
    errors,
    setValue,
    getValues,
    formState,
    triggerValidation,
  } = useForm();

  useEffect(() => {
    if (props && props.examViewQuestionId) {
      setId(props.examViewQuestionId);
    }
  }, []);

  const downloadMediaFile = useCallback(() => {
    const responseType = "blob";
    return get(
      apiPaths.downloadMedia,
      {
        fileName: downloadMedia.mediaName,
        filePath: downloadMedia.mediaSrc,
      },
      {},
      responseType
    )
      .then((res) => {
        setDownloadMedia({});
        setImagePreview({ file: URL.createObjectURL(res) });
      })
      .catch((e) => {
        setDownloadMedia({});
        console.log(e);
      });
  }, [downloadMedia.mediaName, downloadMedia.mediaSrc]);

  useEffect(() => {
    if (Object.keys(downloadMedia)?.length > 0) {
      downloadMediaFile(downloadMedia);
    }
  }, [downloadMedia, downloadMediaFile]);

  useEffect(() => {
    const dataVal = !edit
      ? [questionStatuses.APPROVED]
      : ["SENT FOR APPROVAL", "SAVED", "NEED CORRECTION", "REJECTED"];
    if (+id !== 0) {
      const items = getItemfromStorage("qbData");
      if (items && Object.keys(items).length > 0) {
        const responseData = getItemfromStorage("qbData");
        if (responseData.length > 0) {
          setQBCount(responseData[responseData.length - 1]?.questionId);
        }
        if (+id > 0 && responseData.length > 1) {
          const currentIndex = responseData.findIndex(
            (el) => el.questionId === +id
          );
          setPrevQuestion(
            currentIndex > 0 ? responseData[currentIndex - 1].questionId : null
          );
        }
        if (
          +id < responseData[responseData.length - 1]?.questionId &&
          responseData.length > 1
        ) {
          setNxtQuestion(
            responseData[
              responseData.findIndex((el) => el.questionId === +id) + 1
            ]?.questionId
          );
        }
      } else {
        postData(apiPaths.questionslist, {
          data: dataVal,
        }).then((res) => {
          const responseData = res?.result;
          if (responseData.length > 0) {
            setQBCount(responseData[responseData.length - 1]?.questionId);
          }
          if (+id > 0 && responseData.length > 1) {
            setPrevQuestion(
              responseData[
                responseData.findIndex((el) => el.questionId === +id) - 1
              ]?.questionId
            );
          }
          if (
            +id < responseData[responseData.length - 1]?.questionId &&
            responseData.length > 1
          ) {
            setNxtQuestion(
              responseData[
                responseData.findIndex((el) => el.questionId === +id) + 1
              ]?.questionId
            );
          }
        });
      }
    }
  }, [edit, id]);

  useEffect(() => {
    onWhereUsedButtonClick(+id);
  }, [id]);

  useEffect(() => {
    if (tags) {
      setTagOptions(
        tags.map((tag) => {
          return {
            label: tag.tagName,
            value: tag.tagId,
          };
        })
      );
    }
  }, [tags]);

  useEffect(() => {
    setTopicOptions(
      availableTopics.map((topic) => {
        return {
          label: topic.topic,
          value: topic.topicId,
        };
      })
    );
  }, [availableTopics, availableTopics.length]);

  let onWhereUsedButtonClick = (wQid) => {
    if (!edit) {
      if (+id !== 0 || wQid !== 0) {
        setShowWhereUsedGrid(false);
        setWhereUsedQuestionId(wQid);
        get(`${apiPaths.getQuestionHistory}/${wQid}`, {
          tenantId: getUserDetails().tenantId,
        }).then((res) => {
          plotWhereUsedGrid(res?.result);
        });
        get(
          `${apiPaths.getQuestionFeedbackById}?libTypeList=TEST&libTypeList=QBANK&questionId=${wQid}`,
          {
            tenantId: getUserDetails().tenantId,
          }
        ).then((res) => {
          plotFeedbackGrid(res?.result);
        });
      }
    }
  };

  const plotWhereUsedGrid = (rowData) => {
    const whereUsedPopupgridOptions = {};
    whereUsedPopupgridOptions.pagination = true;
    whereUsedPopupgridOptions.columnDefs = WhereUsedColumnDefs;
    whereUsedPopupgridOptions.rowData = rowData;

    setTimeout(() => whereUsedGridApi?.current?.setRowData(rowData));

    setwhereUsedPopupgridOptions(whereUsedPopupgridOptions);
    setShowWhereUsedGrid(true);
  };

  const plotFeedbackGrid = (rowData) => {
    const feedbackPopupgridOptions = {};
    feedbackPopupgridOptions.pagination = true;
    feedbackPopupgridOptions.columnDefs = FeedbackColumnDefs;
    feedbackPopupgridOptions.rowData = rowData;

    setTimeout(() => feedbackGridApi?.current?.setRowData(rowData));

    setFeedbackPopupgridOptions(feedbackPopupgridOptions);
  };

  useEffect(() => {
    if (courses) {
      setCourseOptions(
        courses.map((course) => {
          return {
            label: course.course,
            value: course.courseId,
          };
        })
      );
    }
  }, [courses]);

  let [displayComments, setDisplayComments] = useState(false);
  let status = useRef();

  let [disableButtons, setDisableButtons] = useState(
    JSON.parse(JSON.stringify(defaultDisableButtonsObject))
  );

  const isValidUpdate = (rows) => {
    if (!rows) {
      return;
    }
    Object.keys(questionStatuses).forEach((qs) => {
      switch (questionStatuses[qs]) {
        case questionStatuses.SENT_FOR_APPROVAL:
          let invalidRowIds1 =
            rows.questionStatus == questionStatuses.SENT_FOR_APPROVAL;
          let Message1 = "Question which is already in Sent For Approval state";
          setDisableButtons((prev) => {
            let a = {};
            a[questionStatuses[qs]] = prev[questionStatuses[qs]];
            a[questionStatuses[qs]]["disable"] = invalidRowIds1 != 0;
            a[questionStatuses[qs]]["Message"] = a[questionStatuses[qs]][
              "disable"
            ]
              ? Message1
              : "";
            return { ...prev, ...a };
          });
          break;
        case questionStatuses.APPROVED:
        case questionStatuses.CORRECTION_NEEDED:
        case questionStatuses.REJECTED:
          let invalidRowIds2 =
            rows.questionStatus !== questionStatuses.SENT_FOR_APPROVAL;
          let Message2 = "Question is not yet Sent For Approval ";
          setDisableButtons((prev) => {
            let a = {};
            a[questionStatuses[qs]] = prev[questionStatuses[qs]];
            a[questionStatuses[qs]]["disable"] = invalidRowIds2 != 0;
            a[questionStatuses[qs]]["Message"] = a[questionStatuses[qs]][
              "disable"
            ]
              ? Message2
              : "";
            return { ...prev, ...a };
          });
          break;
        default:
          return;
      }
    });
  };

  const onClickCommentsOk = () => {
    const data = {
      comment: JSON.stringify(comments),
      newStatus: status.current,
      questionId: [id],
    };

    comments = "";
    setDisplayComments(false);
    postData(apiPaths.updateQuestionStatus, {
      data,
      params: {
        tenantId: getUserDetails()?.tenantId,
        userEmail: getUserDetails()?.email,
      },
    })
      .then((val) => {
        updateQuestion({ ...question, questionStatus: status.current });
        isValidUpdate({ ...question, questionStatus: status.current });
        // if (questionStatuses.APPROVED === status.current) {
        //   updateEdit(false);
        //   //editor.setReadOnly(true);
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateQuestionStatus = (val) => {
    if (isQBPage && val === questionStatuses.APPROVED) {
      onSave("SAVED", val);
    } else {
      setDisplayComments(true);
      status.current = val;
    }
  };

  const frameObject = (result) => {
    if (result)

      isValidUpdate(result);
    updateLoading(false);

    if (!result?.questionId) {
      setAnswers(answer);
    }
    if (result?.questionId) {
      updateQuestion(result);
      setTimeout(() => {
        for (let key in result) {
          if (key === "question_media_map") {
            if (result[key] instanceof Array && result[key]?.length > 0) {
              let mediaInfo = {};
              result[key].forEach((mediaDetails) => {
                if (mediaDetails?.mediaInfo?.mediaType === "IMAGE") {
                  mediaInfo = mediaDetails?.mediaInfo;
                }
              });
              setDownloadMedia(mediaInfo);
              setUploadMediaInformation(mediaInfo);
            } else {
              setUploadMediaInformation({});
            }
          }
          if (key === "question_course_map") {
            const selectedCourses = result?.[key]?.map((course) => {
              return {
                label: course.course,
                value: course.courseId,
              };
            });
            setMultiSelectCourseValue(selectedCourses);
            setValue(key, selectedCourses);
            continue;
          }
          if (key === "question_topic_map") {
            let topics = result?.[key];
            const selectedTopics = topics?.map((topic) => {
              return {
                label: topic.topic,
                value: topic.topicId,
              };
            });
            setMultiSelectTopicValue(selectedTopics);
            setValue(key, selectedTopics);
            continue;
          }

          if (key === "question_tag_map") {
            let tags = result?.[key];
            const selectedTags = tags?.map((tag) => {
              return {
                label: tag.tagName,
                value: tag.tagId,
              };
            });
            setMultiSelectTagValue(selectedTags);
            setValue(key, selectedTags);
            continue;
          }

          if (key === "topics") {
            let topics = result?.[key];
            topics.forEach((ele, index) => {
              setValue("topics" + index, ele?.topicName);
            });
            continue;
          }
          if (key === "answers") {
            result[key] = (result?.[key] || []).sort(
              (a, b) => a?.answerOrder - b?.answerOrder
            );
            setAnswers(result?.[key]);
            let answers = result?.[key];
            let currentJoditValues = { ...joditValues };
            answers.forEach((ele, index) => {
              currentJoditValues["option" + (index + 1)] = ele?.answer;
            });

            setJoditValues({
              ...joditValues,
              ...currentJoditValues,
              subjectId: result.subjectId,
              ...result,
            });
            continue;
          }
          if (key === "answerType") {
            let answers = result?.answers;
            let correctAnswerIds = (answers || [])
              .filter((i) => i.correct)
              .map((ele) => ele.ansOrder + 1);
            let correctOptionsList = answerOptions.filter((i) =>
              correctAnswerIds.includes(i.answerId)
            );
            setMultiSelectValue(correctOptionsList);
            setValue(key, result[key]);
            continue;
          }
          if (
            key === "question" ||
            key === "explanation" ||
            key === "reference"
          ) {
            setJoditValues({ ...joditValues, [key]: result[key] });
            continue;
            //getMultiLineString(result[key]);
          }
          setValue(key, result[key]);
        }
      });
      setAnswers(result.answers);
    }
  };

  useEffect(() => {
    if (+id !== 0) {
      if (id != 0 && getQuestionIds().length > 1) {
        onNavClick("p", true);
        setDisplayNavs(true);
      }
      get(apiPaths.questionbyid, { id })
        .then(({ result }) => {
          console.log("result: ", result);
          frameObject(result);
          setQuestionData(result);
        })
        .catch((val) => frameObject(null));
    } else {
      setAnswers(answer);
      updateLoading(false);
    }
  }, [id, edit, viewQuestion]);

  const displayError = (msg) => <span>{msg}</span>;

  useEffect(() => {
    if (watch("subjectId")) {
      setAvailableTopics(
        topics.filter((topic) => topic.subjectId === +watch("subjectId"))
      );
    }
  }, [getValues, watch("subjectId"), topics, topics.length]);

  const onSave = async (questionStatus, val = null) => {
    if (questionStatus === "CLOSE" && !isQBPage) {
      props.history.push("/app/dashboard");
      return;
    }
    let res = await triggerValidation();
    if (errors && Object.keys(errors)?.length > 0) {
      return;
    }
    let data = {
      ...watch(),
      tenantId: getUserDetails()?.tenantId,
      questionStatus,
      createdBy: getUserDetails().email || "",
      updatedBy: getUserDetails().email || "",
      createdDate: question?.createdDate,
    };
    data.subjectId = +data.subjectId;
    data.question = joditValues?.question;
    data.explanation = joditValues?.explanation;
    data.reference = joditValues?.reference;
    let values = { ...watch(), ...joditValues };
    data.answerType = multiSelectValue.length === 1 ? "Single" : "Multi";
    data.question_course_map = multiSelectCourseValue.map((el) => {
      return {
        courseId: el.value,
      };
    });
    data.question_tag_map = multiSelectTagValue.map((el) => {
      return {
        tagId: el.value,
      };
    });
    data.question_topic_map = multiSelectTopicValue.map((el) => {
      return {
        topicId: el.value,
      };
    });
    data.mediaId = uploadMediaInformation?.mediaId || 0;
    data.topics = [];
    data.answers = answers;
    Object.getOwnPropertyNames(joditValues).forEach((key) => {
      if (key.indexOf("option") !== -1) {
        let index = +key.substr(6, key.length) - 1;
        answers[index].correct = multiSelectValue
          .map((i) => i.answerId)
          .includes(answers[index]?.answerId);
      }
    });
    data.tenantId = getUserDetails().tenantId;
    Object.getOwnPropertyNames(values).forEach((key) => {
      if (key.indexOf("topics") !== -1) {
        let index = +key.substr(6, key.length);
        topics[index].topicName = values[key];
        data.topics.push(topics[index]);
      }
    }, []);
    data.answers = answers.map((el, idx) => {
      return {
        ...el,
        correct: multiSelectValue.some((td) => td.value.includes(idx + 1)),
      };
    });
    if (id !== 0) {
      data["questionId"] = +id;
    }
    data.subject = subjects.filter(
      (el) => el.subjectId === +data.subjectId
    )?.[0]?.subject;
    data.questionType = joditValues?.questionType ?? "EASY";

    postData(apiPaths.question, {
      data,
    })
      .then((res) => {
        if (!isQBPage) {
          props.history.push(`/app/question/${res.result}`);
          window.location.reload();
        } else {
          setDisplayComments(true);
          status.current = val;
        }
      })
      .catch((e) => Toaster(toast.TYPE.ERROR, `Error occured, ${e}`));
  };

  const onNavClick = (button, initial) => {
    let ids = getQuestionIds();
    let index = ids.indexOf(+id);

    if (!initial) {
      if (button === "prev") {
        index--;
      } else {
        index++;
      }
    }
    if (index == 0) {
      if (!disablePrev) setDisablePrev(true);
    } else {
      if (disablePrev) setDisablePrev(false);
    }
    if (index === ids.length - 1 || ids.length === 1) {
      if (!disableNext) setDisableNext(true);
    } else {
      if (disableNext) setDisableNext(false);
    }
    // props.history.push('/app/question/' + ids[index + 1]);
    if (!initial) setId(ids[index]);
  };
  const onsub = () => {
    if (process && process.exit) process.exit(1);
  };

  const back = () => {
    // Navigate back to the previous route while preserving the route state
    history.goBack();
  };

  return (
    <div style={{ display: "flex", width: "100%", flexFlow: "column" }}>
      {loading ? (
        <div>
          <PreLoader />
        </div>
      ) : (
        <div className="addquestion-main">
          {isQBPage && !QBEdit && (
            <Button
              variant="outlined"
              onClick={back}
              style={{ marginTop: "10px", marginBottom: "10px" }}
            >
              Back
            </Button>
          )}
          <div
            className="main-heading"
            style={{
              width: "100%",
              display: "flex",
              marginBottom: "10px",
              justifyContent: "space-between",
            }}
          >
            {!edit ? "View" : +id === 0 ? "Add" : "Edit"} Question
            {edit && +id > 0 && questionData?.questionId && (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  style={{ padding: "0 5px" }}
                  variant="outlined"
                  onClick={() => setViewQuestion(!viewQuestion)}
                >
                  {viewQuestion ? "Edit" : "View"}
                </Button>
                {viewQuestion &&
                  questionData?.questionId &&
                  checkPermission("approve") && (
                    <Button
                      style={{ marginLeft: "5px" }}
                      data-toggle="modal"
                      data-target="#myModal"
                      onClick={() =>
                        updateQuestionStatus(questionStatuses.APPROVED)
                      }
                      disabled={
                        !isAdmin && disableButtons[questionStatuses.APPROVED].disable
                      }
                      title={disableButtons[questionStatuses.APPROVED].Message}
                    >
                      Approve
                    </Button>
                  )}
                {viewQuestion &&
                  questionData?.questionId &&
                  checkPermission("correctionNeeded") && (
                    <Button
                      style={{ marginLeft: "5px" }}
                      onClick={() =>
                        updateQuestionStatus(questionStatuses.CORRECTION_NEEDED)
                      }
                      disabled={
                        !isAdmin && disableButtons[questionStatuses.CORRECTION_NEEDED]
                          .disable
                      }
                      title={
                        disableButtons[questionStatuses.CORRECTION_NEEDED]
                          .Message
                      }
                      data-toggle="modal"
                      data-target="#myModal"
                    >
                      Correction Needed
                    </Button>
                  )}
                {viewQuestion &&
                  questionData?.questionId &&
                  checkPermission("rejected") && (
                    <Button
                      style={{ marginLeft: "5px" }}
                      onClick={() =>
                        updateQuestionStatus(questionStatuses.REJECTED)
                      }
                      disabled={
                        !isAdmin && disableButtons[questionStatuses.REJECTED].disable
                      }
                      title={disableButtons[questionStatuses.REJECTED].Message}
                      data-toggle="modal"
                      data-target="#myModal"
                    >
                      Reject
                    </Button>
                  )}
              </div>
            )}
          </div>
          {edit && (!viewQuestion || +id === 0) && (
            <div>
              <div className="background-common-div">
                <div className="addquestion-sub">
                  <form onSubmit={handleSubmit(onsub)} className="form-div">
                    <div className="btn-div" style={{ float: "right" }}>
                      {edit ? (
                        <React.Fragment>
                          <button
                            className="btn-common"
                            onClick={() => onSave("SAVED")}
                          >
                            Save
                          </button>
                          {checkPermission("sendForApproval") && (
                            <button
                              className="btn-common"
                              onClick={() =>
                                updateQuestionStatus(
                                  questionStatuses.SENT_FOR_APPROVAL
                                )
                              }
                              disabled={
                                disableButtons[
                                  questionStatuses.SENT_FOR_APPROVAL
                                ].disable
                              }
                              title={
                                disableButtons[
                                  questionStatuses.SENT_FOR_APPROVAL
                                ].Message
                              }
                              data-toggle="modal"
                              data-target="#myModal"
                            >
                              Send for Approval
                            </button>
                          )}
                          {checkPermission("approve") && (
                            <button
                              className="btn-common"
                              data-toggle="modal"
                              data-target="#myModal"
                              onClick={() =>
                                updateQuestionStatus(questionStatuses.APPROVED)
                              }
                              disabled={
                                disableButtons[questionStatuses.APPROVED]
                                  .disable && !isQBPage
                              }
                              title={
                                disableButtons[questionStatuses.APPROVED]
                                  .Message
                              }
                            >
                              Approve
                            </button>
                          )}
                          {checkPermission("correctionNeeded") && (
                            <button
                              className="btn-common"
                              onClick={() =>
                                updateQuestionStatus(
                                  questionStatuses.CORRECTION_NEEDED
                                )
                              }
                              disabled={
                                disableButtons[
                                  questionStatuses.CORRECTION_NEEDED
                                ].disable
                              }
                              title={
                                disableButtons[
                                  questionStatuses.CORRECTION_NEEDED
                                ].Message
                              }
                              data-toggle="modal"
                              data-target="#myModal"
                            >
                              Correction Needed
                            </button>
                          )}
                          {checkPermission("rejected") && (
                            <button
                              className="btn-common"
                              onClick={() =>
                                updateQuestionStatus(questionStatuses.REJECTED)
                              }
                              disabled={
                                disableButtons[questionStatuses.REJECTED]
                                  .disable
                              }
                              title={
                                disableButtons[questionStatuses.REJECTED]
                                  .Message
                              }
                              data-toggle="modal"
                              data-target="#myModal"
                            >
                              Reject
                            </button>
                          )}
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                      {props.examViewQuestionId === undefined && !isQBPage && (
                        <div class="close-btn" onClick={() => onSave("CLOSE")}>
                          <i class="fa fa-close" aria-hidden="true"></i>
                        </div>
                      )}
                    </div>

                    <div className="common-div">
                      <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <div className="form-sub-div">
                            <h6 className="text-bold">Subject</h6>
                            <div className="form-elements">
                              {edit ? (
                                <select
                                  className="form-details questions"
                                  name="subjectId"
                                  ref={register({ required: true })}
                                  onChange={(e) => {
                                    setJoditValues({
                                      ...joditValues,
                                      subjectId: e.target.value,
                                    });
                                  }}
                                  readOnly={!edit}
                                >
                                  {subjects.map((ele) => (
                                    <option
                                      key={ele?.subjectId}
                                      value={ele?.subjectId}
                                    >
                                      {ele?.subject}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <input
                                  className="form-details"
                                  value={question.subject}
                                  readOnly
                                />
                              )}
                            </div>
                          </div>

                          <div className="form-sub-div">
                            <h6 className="text-bold">Courses</h6>
                            <div className="form-elements">
                              <MultiSelect
                                disabled={!edit}
                                ref={register({ required: true })}
                                options={courseOptions} // Options to display in the dropdown
                                value={multiSelectCourseValue} // Preselected value to persist in dropdown
                                onChange={setMultiSelectCourseValue} // Function will trigger on select event
                                labelledBy={"Please Select"}
                                hasSelectAll={true}
                              />
                            </div>
                          </div>
                          <div className="form-sub-div">
                            <h6 className="text-bold">Tags</h6>
                            <div className="form-elements">
                              <MultiSelect
                                disabled={!edit}
                                ref={register({ required: true })}
                                options={tagOptions} // Options to display in the dropdown
                                value={multiSelectTagValue} // Preselected value to persist in dropdown
                                onChange={setMultiSelectTagValue} // Function will trigger on select event
                                labelledBy={"Please Select"}
                                hasSelectAll={true}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <div className="form-sub-div">
                            <h6 className="text-bold">Topic</h6>
                            <div className="form-elements">
                              <MultiSelect
                                disabled={!edit}
                                ref={register({ required: true })}
                                options={topicOptions} // Options to display in the dropdown
                                value={multiSelectTopicValue} // Preselected value to persist in dropdown
                                onChange={setMultiSelectTopicValue} // Function will trigger on select event
                                labelledBy={"Please Select"}
                                hasSelectAll={true}
                              />
                            </div>
                          </div>
                          <div className="form-sub-div">
                            <h6 className="text-bold">Complexity</h6>
                            <div className="form-elements">
                              <select
                                className="form-details questions"
                                name="questionType"
                                value={joditValues?.questionType}
                                readOnly={!edit}
                                onChange={(e) => {
                                  setJoditValues({
                                    ...joditValues,
                                    questionType: e.target.value,
                                  });
                                }}
                              >
                                <option>EASY</option>
                                <option>MEDIUM</option>
                                <option>HARD</option>
                              </select>
                            </div>
                          </div>
                          <div className="form-sub-div">
                            <h6 className="text-bold">Correct Option</h6>
                            <div className="form-elements">
                              {edit ? (
                                <div>
                                  <div class="">
                                    <MultiSelect
                                      options={answerOptions} // Options to display in the dropdown
                                      value={multiSelectValue} // Preselected value to persist in dropdown
                                      onChange={setMultiSelectValue} // Function will trigger on select event
                                      labelledBy={"Please Select"}
                                      hasSelectAll={false}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <input
                                  className="form-details"
                                  type="text"
                                  value={answers
                                    .filter((answer) => answer.correct)
                                    .map(
                                      (ele, index) =>
                                        "Option" + (ele.ansOrder + 1)
                                    )
                                    .join(", ")}
                                  readOnly
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <div className="form-sub-div">
                            <h6 className="text-bold">Question *</h6>
                            <div className="form-elements">
                              <JoditEditor
                                ref={editor}
                                value={joditValues["question"]}
                                config={{
                                  askBeforePasteHTML: false,
                                  askBeforePasteFromWord: false,
                                  readonly: !edit,
                                  enableDragAndDropFileToEditor: true,
                                  uploader: {
                                    insertImageAsBase64URI: true,
                                  },
                                  height: 350,
                                }}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={(e) => {
                                  setJoditValues({
                                    ...joditValues,
                                    question: e?.target?.innerHTML || e,
                                  });
                                }} // preferred to use only this option to update the content for performance reasons
                                onChange={(newContent) => { }}
                              />

                              <div class="error-msg">
                                {errors?.question &&
                                  displayError("Question is required")}
                              </div>
                            </div>
                          </div>

                          <div className="form-sub-div form-sub-div-nomargin">
                            {edit}
                            {answers.map((ele, ind) => {
                              return (
                                <div
                                  key={"Option" + (ind + 1)}
                                  className="option-sub"
                                >
                                  <h6 className="text-bold">
                                    {"Option" + (ind + 1)}
                                  </h6>
                                  <div className="form-elements">
                                    <JoditEditor
                                      ref={editor}
                                      value={joditValues["option" + (ind + 1)]}
                                      config={config}
                                      tabIndex={1} // tabIndex of textarea
                                      onBlur={(e) => {
                                        const ans = [...answers];
                                        ans[ind]["answer"] =
                                          e?.target?.innerHTML || e;
                                        setAnswers(ans);
                                      }} // preferred to use only this option to update the content for performance reasons
                                      onChange={(newContent) => { }}
                                    />
                                    <div class="error-msg">
                                      {errors?.["option" + (ind + 1)] &&
                                        displayError(
                                          "Option" + (ind + 1) + " is required"
                                        )}{" "}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          <div className="form-sub-div">
                            <h6 className="text-bold">Explanation</h6>
                            <div className="form-elements">
                              <JoditEditor
                                ref={editor}
                                value={joditValues["explanation"]}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={(e) => {
                                  setJoditValues({
                                    ...joditValues,
                                    explanation: e?.target?.innerHTML || e,
                                  });
                                }} // preferred to use only this option to update the content for performance reasons
                                onChange={(newContent) => { }}
                              />
                              <div class="error-msg">
                                {errors?.explanation &&
                                  displayError("Explanation is required")}{" "}
                              </div>
                            </div>
                          </div>

                          <div className="form-sub-div">
                            <h6 className="text-bold">Reference</h6>
                            <div className="form-elements">
                              <JoditEditor
                                ref={editor}
                                value={joditValues["reference"]}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={(e) =>
                                  setJoditValues({
                                    ...joditValues,
                                    reference: e?.target?.innerHTML || e,
                                  })
                                } // preferred to use only this option to update the content for performance reasons
                                onChange={(newContent) => { }}
                              />
                              <div class="error-msg">
                                {errors?.explanation &&
                                  displayError("Reference is required")}{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {errors?.Topics}
                  </form>
                </div>
              </div>
              <div className="btn-list-div">
                {displyNavs ? (
                  <React.Fragment>
                    <button
                      className="btn-common"
                      onClick={() => onNavClick("prev")}
                      disabled={disablePrev}
                    >
                      Previous
                    </button>{" "}
                    <span style={{ margin: "0 12px" }}>
                      {getQuestionIds().indexOf(+id) +
                        1 +
                        " of " +
                        getQuestionIds().length}
                    </span>
                    <button
                      className="btn-common"
                      disabled={disableNext}
                      onClick={() => onNavClick("next")}
                    >
                      Next
                    </button>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <div
        class="modal fade show"
        role="dialog"
        style={{ display: displayComments ? "block" : "" }}
      >
        <div class="modal-dialog modal-dialog-custom">
          <div class="modal-content">
            <div class="modal-header modal-header-custom">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() => {
                  setDisplayComments(false);
                }}
              >
                <div class="close-btn">
                  <i class="fa fa-close" aria-hidden="true"></i>
                </div>
              </button>
            </div>
            <div class="modal-body modal-body-custom">
              {displayComments ? (
                <div class="comments-div">
                  <div class="comments-text-div">Add comments</div>
                  <textarea
                    class="textarea-custom"
                    onChange={($event) => (comments = $event.target.value)}
                    value={comments}
                  ></textarea>
                  <button
                    class="btn-common float-right"
                    onClick={() => onClickCommentsOk()}
                    data-dismiss="modal"
                  >
                    OK
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      {(!edit || (viewQuestion && +id > 0)) && (
        <QuestionViewer
          whereUsedPopupgridOptions={whereUsedPopupgridOptions}
          feedbackPopupgridOptions={feedbackPopupgridOptions}
          prevQuestion={prevQuestion}
          nxtQuestion={nxtQuestion}
          {...questionData}
          setId={setId}
          count={QBCount}
          showWhereUsedGrid={showWhereUsedGrid}
        />
      )}
    </div>
  );
};

export default AddQuestion;
